import React from "react";
import { Col } from "react-bootstrap";

import { IEmpleado } from "../models/interfaces/IEmpleado";

import StarIcon from "@mui/icons-material/Star";
import SchoolIcon from "@mui/icons-material/School";

import polo from "../assets/images/trabajadores/poloJSerio.jpg";
import beto from "../assets/images/trabajadores/betoSerio.jpg";
import isis from "../assets/images/trabajadores/isisSeria.jpg";
import elsy from "../assets/images/trabajadores/elsySerio.jpg";
import luis from "../assets/images/trabajadores/luisSerio.jpeg";
import enrique from "../assets/images/trabajadores/enriqueSerio.jpg";
import johana from "../assets/images/trabajadores/johanaSerio.jpg";
import alejandro from "../assets/images/trabajadores/alejandroSerio.jpg";

import poloAlt from "../assets/images/trabajadores/poloJChamba.jpg";
import betoAlt from "../assets/images/trabajadores/betoChamba.jpg";
import isisAlt from "../assets/images/trabajadores/isisChamba.jpg";
import elsyAlt from "../assets/images/trabajadores/elsyChamba.jpg";
import luisAlt from "../assets/images/trabajadores/luisChamba.jpeg";
import enriqueAlt from "../assets/images/trabajadores/enriqueChamba.jpg";
import johanaAlt from "../assets/images/trabajadores/johanaChamba.jpg";
import alejandroAlt from "../assets/images/trabajadores/alejandroChamba.jpg";
export const teamworkData: IEmpleado[] = [
  //Polo Maldonado
  {
    nombreCompleto: "Polo Maldonado",
    nombre: "Marco Polo",
    apellido: "Maldonado Rayas",
    descripcion:
      "Apasionado en la re-ingeniería de procesos, con alta experiencia en organización de empresas y negociación efectiva, mi principal función radica en la supervisión de proyectos de innovación tecnológica y en la detección oportuna de las necesidades cambiantes del mercado a través de la mezcla de tecnología, conocimientos e innovación.",
    lema: "La estrategia en los proyectos la aporta usted, la ingeniería de proyectos, MSW.",
    titulo: "Director general",
    alt: "Polo Maldonado",
    src: `${polo}`,
    estudio: (
      <>
        <Col lg={1}>
          <SchoolIcon color="primary" />
        </Col>
        <Col lg={11}>
          <div className="text-white text-justify">
            <p>Ingeniero Químico Metalúrgico</p>
          </div>
        </Col>
      </>
    ),
    reconocimiento: (
      <>
        <Col lg={1}>
          <StarIcon color="primary" />
        </Col>
        <Col lg={11}>
          <div className="text-white text-justify">
            <p>
              Administración de proyectos | Mejora Continua | Negociación |
              Planificación Estratégica | Minería | Ingeniería de Procesos
            </p>
          </div>
        </Col>
      </>
    ),
    id: 1,
    srcAlt: `${poloAlt}`,
    filter: "sepia(80%)",
  },

  //Alberto Sánchez
  {
    nombreCompleto: "Alberto Sánchez",
    nombre: "Alberto",
    apellido: "Sánchez Cano",
    descripcion: "Me considero una persona comprometida, confiable y emprendedora.",
    lema: "La acción es la clave para moldear el futuro.",
    titulo: "Director operativo",
    alt: "Alberto Sánchez",
    src: `${beto}`,
    estudio: (
      <>
        <Col lg={1}>
          <SchoolIcon color="primary" />
        </Col>
        <Col lg={11}>
          <div className="text-white text-justify">
            <p>Ingeniero Químico Metalúrgico</p>
          </div>
        </Col>
      </>
    ),
    // reconocimiento: (
    //   <>
    //     <Col lg={1}>
    //       <StarIcon color="primary" />
    //     </Col>
    //     <Col lg={11}>
    //       <div className="text-white text-justify">
    //         <p>Siempre disponible para aprender y resolver problemas.</p>
    //       </div>
    //     </Col>
    //   </>
    // ),
    id: 2,
    srcAlt: `${betoAlt}`,
    filter: "sepia(80%)",
  },

  //Isis Segundo
  {
    nombreCompleto: "Isis Segundo",
    nombre: "Isis Judith",
    apellido: "Segundo Lauriano",
    descripcion: "Me considero una persona responsable, pro activa y honesta.",
    lema: "Solo yo puedo cambiar mi vida. Nadie puede hacerlo por mí",
    titulo: "Administrador contable.",
    alt: "Isis Segundo",
    src: `${isis}`,
    estudio: (
      <>
        <Col lg={1}>
          <SchoolIcon color="primary" />
        </Col>
        <Col lg={11}>
          <div className="text-white text-justify">
            <p>Licenciada en Administración</p>
          </div>
        </Col>
      </>
    ),
    // reconocimiento: (
    //   <>
    //     <Col lg={1}>
    //       <StarIcon color="primary" />
    //     </Col>
    //     <Col lg={11}>
    //       <div className="text-white text-justify">
    //         <p>Siempre disponible para aprender y resolver problemas.</p>
    //       </div>
    //     </Col>
    //   </>
    // ),
    id: 3,
    srcAlt: `${isisAlt}`,
    filter: "sepia(80%)",
  },

  //Elsy Bravo
  {
    nombreCompleto: "Elsy Bravo",
    nombre: "Elsy Yacaranday",
    apellido: "Bravo Michel",
    descripcion: "Me considero una persona dedicada, responsable y proactiva.",
    lema: "Sé el cambio que quieres ver en el mundo",
    titulo: "Administración y recursos humanos.",
    alt: "Elsy Bravo",
    src: `${elsy}`,
    estudio: (
      <>
        <Col lg={1}>
          <SchoolIcon color="primary" />
        </Col>
        <Col lg={11}>
          <div className="text-white text-justify">
            <p>Licenciada en Administración</p>
          </div>
        </Col>
      </>
    ),
    // reconocimiento: (
    //   <>
    //     <Col lg={1}>
    //       <StarIcon color="primary" />
    //     </Col>
    //     <Col lg={11}>
    //       <div className="text-white text-justify">
    //         <p>Siempre disponible para aprender y resolver problemas.</p>
    //       </div>
    //     </Col>
    //   </>
    // ),
    id: 4,
    srcAlt: `${elsyAlt}`,
    filter: "sepia(80%)",
  },

  //Luis Muñiz
  {
    nombreCompleto: "Luis Muñiz",
    nombre: "Luis Alberto",
    apellido: "Muñiz Zavaleta",
    descripcion:
      "Me considero una persona autodidacta, todo el tiempo trato de aprender nuevas tecnologías. Me gusta bastante la programación, en especial el desarrollo web y móvil.",
    lema: "Nunca es suficiente, siempre existe algo nuevo por aprender",
    titulo: "Topografo",
    alt: "Luis Muñiz",
    src: `${luis}`,
    estudio: (
      <>
        <Col lg={1}>
          <SchoolIcon color="primary" />
        </Col>
        <Col lg={11}>
          <div className="text-white text-justify">
            <p>Ingeniero en Topografía</p>
          </div>
        </Col>
      </>
    ),
    // reconocimiento: (
    //   <>
    //     <Col lg={1}>
    //       <StarIcon color="primary" />
    //     </Col>
    //     <Col lg={11}>
    //       <div className="text-white text-justify">
    //         <p>Siempre disponible para aprender y resolver problemas.</p>
    //       </div>
    //     </Col>
    //   </>
    // ),
    id: 5,
    srcAlt: `${luisAlt}`,
    filter: "sepia(80%)",
  },

  //Luis Estrada
  {
    nombreCompleto: "Luis Estrada",
    nombre: "Luis Enrique",
    apellido: "Estrada Díaz",
    descripcion:
      "Soy capaz, íntegro, responsable, respetuoso y ambicioso por aprender",
    lema: "Propongo, me esfuerzo y lo logro",
    titulo: "Topografo",
    alt: "Luis Estrada",
    src: `${enrique}`,
    estudio: (
      <>
        <Col lg={1}>
          <SchoolIcon color="primary" />
        </Col>
        <Col lg={11}>
          <div className="text-white text-justify">
            <p>Ingeniero en Topografía</p>
          </div>
        </Col>
      </>
    ),
    reconocimiento: (
      <>
        <Col lg={1}>
          <StarIcon color="primary" />
        </Col>
        <Col lg={11}>
          <div className="text-white text-justify">
            <p>
              Analista topográfico | Desarrollador de trabajos topográficos |
              Cumplo todas mis metas que me propongo
            </p>
          </div>
        </Col>
      </>
    ),
    id: 6,
    srcAlt: `${enriqueAlt}`,
    filter: "sepia(80%)",
  },

  //Johana Mejía
  {
    nombreCompleto: "Johana Mejía",
    nombre: "Johana Jaqueline",
    apellido: "Mejía Ramírez",
    descripcion:
      "Me considero una persona autodidacta, todo el tiempo trato de aprender nuevas tecnologías. Me gusta bastante la programación, en especial el desarrollo web y móvil.",
    lema: "Nunca es suficiente, siempre existe algo nuevo por aprender",
    titulo: "Topografa",
    alt: "Johana Mejía",
    src: `${johana}`,
    estudio: (
      <>
        <Col lg={1}>
          <SchoolIcon color="primary" />
        </Col>
        <Col lg={11}>
          <div className="text-white text-justify">
            <p>Ingeniera en Topografía</p>
          </div>
        </Col>
      </>
    ),
    // reconocimiento: (
    //   <>
    //     <Col lg={1}>
    //       <StarIcon color="primary" />
    //     </Col>
    //     <Col lg={11}>
    //       <div className="text-white text-justify">
    //         <p>Siempre disponible para aprender y resolver problemas.</p>
    //       </div>
    //     </Col>
    //   </>
    // ),
    id: 7,
    srcAlt: `${johanaAlt}`,
    filter: "sepia(80%)",
  },

  //Alejandro Zapien
  {
    nombreCompleto: "Alejandro Zapien",
    nombre: "Alejandro",
    apellido: "Zapien Nicolas",
    descripcion:
      "Me considero una persona autodidacta, todo el tiempo trato de aprender nuevas tecnologías. Me gusta bastante la programación, en especial el desarrollo web y móvil.",
    lema: "Nunca es suficiente, siempre existe algo nuevo por aprender",
    titulo: "Topografo",
    alt: "Alejandro Zapien",
    src: `${alejandro}`,
    estudio: (
      <>
        <Col lg={1}>
          <SchoolIcon color="primary" />
        </Col>
        <Col lg={11}>
          <div className="text-white text-justify">
            <p>Ingeniero en Topografía</p>
          </div>
        </Col>
      </>
    ),
    // reconocimiento: (
    //   <>
    //     <Col lg={1}>
    //       <StarIcon color="primary" />
    //     </Col>
    //     <Col lg={11}>
    //       <div className="text-white text-justify">
    //         <p>
    //           Analista topográfico | Desarrollador de trabajos topográficos |
    //           Cumplo todas mis metas que me propongo
    //         </p>
    //       </div>
    //     </Col>
    //   </>
    // ),
    id: 8,
    srcAlt: `${alejandroAlt}`,
    filter: "sepia(80%)",
  },
];
